import { Injectable } from '@angular/core';
import SumoLogger, { SumoLoggerOptions } from 'sumo-logger';

/**
 * The provider for Sumo Logic.
 * Added the provider as a reminder that we might have different logger in the future.
 *
 * @export
 * @class LoggerProvider
 */
@Injectable({ providedIn: 'root' })
export class LoggerProvider {
  private logger!: SumoLogger;

  /**
   * The logger initializer. Should only be invoked as a step from the App Initializer
   *
   * @param {(SumoLoggerOptions | undefined)} opt
   * @returns
   * @memberof LoggerProvider
   */
  init(opt: SumoLoggerOptions | undefined): boolean {
    if (opt) {
      opt = this.setRuntimeOpt(opt);
      this.logger = new SumoLogger(opt);
      return true;
    }

    console.log('External logger provider not initialized. Using console log');
    return false;
  }

  /**
   * Set some properties that are relevant to identify the current tenant
   *
   * @private
   * @param {SumoLoggerOptions} opt
   * @returns
   * @memberof LoggerProvider
   */
  private setRuntimeOpt(opt: SumoLoggerOptions) {
    return {
      ...opt,
      ...{
        clientUrl: window.location.href,
        hostName: window.location.hostname,
        onError: () =>
          console.log('Failed to submit log details to logger collector'),
      },
    };
  }

  /**
   * Expose the logger to the logger service so it can be consumed anywhere in the app.
   *
   * @returns
   * @memberof LoggerProvider
   */
  getLogger(): SumoLogger {
    return this.logger ?? console;
  }
}
